import React, {useState} from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import "./App.css"; // Ensure this file contains the required styles
import Sidebar from "./components/Sidebar/Sidebar";
import Templat from "./components/Templat/Templat";
import Chatbot from "./components/Chatbot/Chatbot";
import Step1 from "./pages/Step1/Step1";
import Step2 from "./pages/Step2/Step2";
import Step3 from "./pages/Step3/Step3";
import Step4 from "./pages/Step4/Step4";
import Step5 from "./pages/Step5/Step5";
import BusinessTemp from "./pages/BusinessTemplates/BusinessTemp";

const App = () => {
  const [isNewChat, setIsNewChat] = useState(false);

  // const [showChatbot, setShowChatbot] = useState(false);

  // const handleChatStart = () => {
  //   setShowChatbot(true);
  // };

  // const [isNewChat, setIsNewChat] = useState(false);

  // const handleNewChat = () => {
  //   setIsNewChat(true);
  //   setTimeout(() => setIsNewChat(false), 100); // Reset after triggering
  // };

    return (
      <Router>
      <div className="container">
        <Sidebar setIsNewChat={setIsNewChat}/>
        <div className="main-content">
          <Routes>
            <Route path="/" element={<Templat/>} />
            <Route path="/chatbot" element={<Chatbot isNewChat={isNewChat} setIsNewChat={setIsNewChat}/>} />
            <Route path="/steps/step1" element={<Step1/>} />
            <Route path="/steps/step2" element={<Step2/>} />        
            <Route path="/steps/step3" element={<Step3/>} />        
            <Route path="/steps/step4" element={<Step4/>} />        
            <Route path="/steps/step5" element={<Step5/>} />        
            <Route path="/templates" element={<BusinessTemp/>} />        
          </Routes>
        </div>
    
      </div> 
   
      </Router>
  );
};

export default App;
